import React from 'react';

export interface FormSectionTitleProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const FormSectionTitle: React.FC<FormSectionTitleProps> = ({
    children,
    className = '',
    style = {},
}) => {
    const titleStyles: React.CSSProperties = {
        fontSize: '13px',
        fontWeight: 600,
        color: 'var(--malachite-text-primary)',
        paddingLeft: '8px',
        lineHeight: '1.4',
        margin: 0,
        ...style,
    };

    return (
        <div className={className} style={titleStyles}>
            {children}
        </div>
    );
};

export default FormSectionTitle;
